export const LOAD_USER_DATA="LOAD_USER_DATA";
export const SIGN_UP="SIGN_UP";
export const SIGN_IN="SIGN_IN";